import { z } from 'zod';
import apiClient from '../client';

const chatbotMessageSchema = z.object({
  message: z.string().min(1)
});

export const chatbot = {
  sendMessage: async (data: z.infer<typeof chatbotMessageSchema>) => {
    const validated = chatbotMessageSchema.parse(data);
    const response = await apiClient.post('/chatbot/message', validated);
    return response.data;
  },

  sendImageMessage: async (image: File, message: string, conversationHistory: any[] = []) => {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('message', message);
    formData.append('conversationHistory', JSON.stringify(conversationHistory));

    const response = await apiClient.post('/chatbot/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};